import { css } from '@emotion/react';

import type { Theme } from '@coursera/cds-core';

const styles = {
  paragraphAndButtonPadding: (theme: Theme) => css`
    padding-bottom: ${theme.spacing(24)};
  `,
  modalContentSegmentPadding: (theme: Theme) => css`
    padding-bottom: ${theme.spacing(48)};
  `,
};

export default styles;
